// Shared storage keys for authentication and user data
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'pathbuddy_access_token',
  REFRESH_TOKEN: 'pathbuddy_refresh_token',
  USER_DATA: 'pathbuddy_user',
  REMEMBER_ME: 'pathbuddy_remember',
  USER_EMAIL: 'pathbuddy_user_email',
  /** Absolute login session start (ms). Session ends after 24h regardless of activity. */
  SESSION_STARTED_AT: 'pathbuddy_session_started_at',
  PENDING_HANDOFF_TOKEN: 'pending_handoff_token',
  PENDING_HANDOFF_PROMPT_ID: 'pending_handoff_prompt_id',
  PENDING_HANDOFF_RETRY_TOKEN: 'pending_handoff_retry_token',
  /** Join code from a /join/<code> link, held until the user is signed in. */
  PENDING_JOIN_CODE: 'pending_join_code',
  /** Set in sessionStorage when the leaving-year prompt is dismissed for this session. */
  LEAVING_YEAR_PROMPT_DISMISSED: 'leaving_year_prompt_dismissed',
  /** Set in localStorage when the "Pathbuddy is now IVORI" banner is closed. */
  PATHBUDDY_MOVED_DISMISSED: 'ivori_pathbuddy_moved_dismissed'
};

/** Absolute session length shown in the inactivity / session-expired overlay. */
export const SESSION_MAX_MS = 24 * 60 * 60 * 1000;

